<template>
  <div :class="['facility-bar-menu', 'parent-bg', { expanded: isExpanded }]">
    <p v-if="content.facility_title || content.facility_h1 || content.commercialName" class="bold name">
      {{ content.facility_title || content.facility_h1 || content.commercialName }}
    </p>

    <ul id="facility-bar-panel" class="facility-bar-list">
      <li v-if="formattedPhoneNumber?.length" class="facility-bar-list-item">
        <SimpleButton
          :href="`tel:${formattedPhoneNumber}`"
          class="phone-button"
          @click="() => tracking({ event: 'click.action', click: 'call', click_chapter1: 'sticky_hero', click_chapter2: 'CTA' })"
        >
          <SvgIcon name="func_call2" class="icon" />
          <span>
            <p class="bold">{{ callCenterPhoneNumber || content.phoneNumber }}</p>
            <p v-if="content.menu[0].phone_schedules" class="baseline">{{ content.menu[0].phone_schedules }}</p>
          </span>
        </SimpleButton>
      </li>

      <li v-if="!isPublicGestionType && content.menu[0].can_callback" class="facility-bar-list-item">
        <SimpleButton @click="handleCallbackClick">
          {{ useMicroCopy('facilitybar.callbackcta.label') }}
        </SimpleButton>
      </li>

      <li v-if="!isPublicGestionType && content.menu[0].can_visit" class="facility-bar-list-item">
        <SimpleButton :solid="true" @click="handleVisitClick">
          {{ useMicroCopy('facilitybar.visitcta.label') }}
        </SimpleButton>
      </li>

      <li v-if="content.menu[0].cta_label_1 && content.menu[0].cta_link_1?.story?.url" class="facility-bar-list-item">
        <SimpleButton @click="handleCustomForm1Click">{{ content.menu[0].cta_label_1 }}</SimpleButton>
      </li>

      <li v-if="content.menu[0].cta_label_2 && content.menu[0].cta_link_2?.story?.url" class="facility-bar-list-item">
        <SimpleButton :solid="true" @click="handleCustomForm2Click">{{ content.menu[0].cta_label_2 }}</SimpleButton>
      </li>
    </ul>
  </div>
</template>

<script setup>
import SimpleButton from '@/components/SimpleButton.vue'
import SvgIcon from '@/components/SvgIcon.vue'
import { inject } from 'vue'

const props = defineProps({
  content: Object,
  formattedPhoneNumber: String,
  callCenterPhoneNumber: String,
  isPublicGestionType: Boolean,
  isExpanded: Boolean,
  tracking: Function
})

// inject modals
const openCallbackModal = inject('callback', () => {})
const openVisitModal = inject('facility-visit', () => {})
const openCustomForm1Modal = inject('custom-form-1', () => {})
const openCustomForm2Modal = inject('custom-form-2', () => {})

const handleCallbackClick = () => {
  props.tracking({ event:'click.action', click:'callback', click_chapter1:'sticky_hero', click_chapter2:'CTA', form_name: getInquiryFormName('callback') })
  openCallbackModal()
}
const handleVisitClick = () => {
  props.tracking({ event:'click.action', click:'visit', click_chapter1:'sticky_hero', click_chapter2:'CTA', form_name: getInquiryFormName('visit') })
  openVisitModal()
}
const handleCustomForm1Click = () => { openCustomForm1Modal(); props.tracking({ event:'click.action', click:'custom_form_1', click_chapter1:'sticky_hero', click_chapter2:'CTA' }) }
const handleCustomForm2Click = () => { openCustomForm2Modal(); props.tracking({ event:'click.action', click:'custom_form_2', click_chapter1:'sticky_hero', click_chapter2:'CTA' }) }
</script>

<style lang="scss" scoped>
.facility-bar-menu {
  display: flex;
  justify-content: space-between;
  align-items: center;
  @include pair-7;
  border-radius: $radius-xs;
  border: $border-grey;
  padding: 0 2.025%;
  min-height: 3rem;
  text-align: center;
  width: 100%;

  @include for-tablet-landscape-up {
    padding-top: 0.63rem;
    padding-bottom: 0.63rem;
    min-height: 4rem;
    position: sticky;
    top: 1.25rem;
    bottom: auto;
    left: 0;
    transform: none;
    text-align: start;
  }

  &.expanded {
    margin-bottom: 0;
    padding: 0;
    flex-wrap: wrap;
    flex-direction: column;
    border: 0;

    .facility-bar-list {
      margin-top: 2rem;
      flex-direction: column;
      align-items: center;
      width: 100%;
    }

    .facility-bar-list-item {
      margin-left: 0;
      width: 100%;
      justify-content: center;

      &:not(:first-child) {
        margin-top: 0.625rem;
      }
    }

    .simple-button {
      width: 100%;
    }
  }

  .name {
    max-width: calc(100% - 32px);
    @include size-l;

    @include for-tablet-landscape-up {
      @include size-s;
      max-width: none;
    }
  }

  .facility-bar-list {
    display: flex;
    z-index: 1;
  }

  .facility-bar-list-item {
    display: flex;
    align-items: center;
    margin-left: 0.62rem;

    .simple-button .icon {
      width: 2rem;
      height: 2rem;
      flex: none;
    }
  }

  :deep(.simple-button) {
    &.phone-button {
      padding-left: 0;
      padding-right: 0;
      font-size: 1.125rem;
      line-height: 120%;

      &::before {
        background: none;
      }

      .icon {
        color: var(--gradient-start);

        path {
          fill: var(--gradient-start);
        }
      }
    }
  }
  .baseline {
    font-size: 0.625rem;
    line-height: 140%;
    color: var(--text-70);
  }
}
</style>